import { LocalizationService } from '@abp/ng.core';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ReceiverDto } from 'src/core/models/receiver/receiver.dto';
import { CrudService } from 'src/core/services/crud/crud.service';

@Component({
  selector: 'receiver-add-modal',
  templateUrl: './receiver-add-modal.component.html',
  styleUrl: './receiver-add-modal.component.scss',
})
export class ReceiverAddModalComponent {
  @Output()
  onInsertSaved: EventEmitter<{}> = new EventEmitter();

  form = this.fb.group({
    name: ['', [Validators.required]],
    email: ['', [Validators.required]],
    phone: ['', [Validators.required]]
  });

  newReceiver: ReceiverDto = new ReceiverDto();
  inProgress: boolean;
  isModalOpen: boolean;

  constructor(private fb: FormBuilder, private crudService: CrudService, private L: LocalizationService) {
  }


  save() {
    if (this.form.invalid) {
      return;
    }
    this.inProgress = true;
    this.newReceiver.name = this.form.controls["name"].value;
    this.newReceiver.email = this.form.controls["email"].value;
    this.newReceiver.phone = this.form.controls["phone"].value;

    this.crudService
      .insertWithoutId<ReceiverDto>(ReceiverDto, this.newReceiver)
      .subscribe((result) => {
        if (result) {
          this.onInsertSaved.emit();
        }
        this.isModalOpen = false;
        this.inProgress = false;
        this.form.reset();
      });
  }

  load(data: ReceiverDto | null) {
    if (data == null) {
      data = new ReceiverDto();
    } else {
      this.newReceiver = data;
      this.form.patchValue(data);
    }
  }

}